import { HighlightOutlined } from '@ant-design/icons';
import { Card, Divider, Timeline, Typography } from 'antd';
import moment from 'moment';

import { InterviewHistoryChangedFields } from '../../types';
import { CandidateHistoryCollectionSerializer } from '../../types/api';

interface ApplicantInterviewEventTimelineProps {
  createdAt: string;
  recruiterName: string;
  opportunityTitle?: string;
  interviewHistoryEventType: CandidateHistoryCollectionSerializer['interview_history_type'];
  interviewHistoryChangedFields?: InterviewHistoryChangedFields;
  atStage: string;
}

const ApplicantInterviewEventTimeline = ({
  recruiterName,
  createdAt,
  opportunityTitle,
  atStage,
  interviewHistoryEventType,
  interviewHistoryChangedFields,
}: ApplicantInterviewEventTimelineProps) => {
  return (
    <Timeline.Item dot={<HighlightOutlined />}>
      <Card>
        <Typography.Text type="secondary">{moment(createdAt).format('LLL')}</Typography.Text>
        <br />
        <Typography.Text strong>{recruiterName}</Typography.Text>{' '}
        {interviewHistoryEventType === 'INTERVIEW_STARTED' && (
          <Typography.Text>iniciou a entrevista </Typography.Text>
        )}
        {interviewHistoryEventType === 'INTERVIEW_FINISHED' && (
          <Typography.Text>finalizou a entrevista </Typography.Text>
        )}
        {interviewHistoryEventType === 'INTERVIEW_CHANGED' && (
          <Typography.Text>fez alterações na entrevista </Typography.Text>
        )}
        na etapa <Typography.Text strong>{atStage}</Typography.Text> na vaga{' '}
        <Typography.Text strong>{opportunityTitle}</Typography.Text>.
        {interviewHistoryEventType === 'INTERVIEW_CHANGED' && (
          <>
            <Divider />
            Campos alterados:
            <br />
            <br />
            {interviewHistoryChangedFields?.opinion_status === 'IN_ANALYSIS' && (
              <>
                <Typography.Text>
                  Parecer da entrevista:{' '}
                  <Typography.Text type="warning" strong>
                    Em análise
                  </Typography.Text>
                </Typography.Text>
                <br />
              </>
            )}
            {interviewHistoryChangedFields?.opinion_status === 'QUALIFIED' && (
              <>
                <Typography.Text>
                  Parecer da entrevista:{' '}
                  <Typography.Text type="success" strong>
                    Qualificado
                  </Typography.Text>
                </Typography.Text>
                <br />
              </>
            )}
            {interviewHistoryChangedFields?.opinion_status === 'NOT_QUALIFIED' && (
              <>
                <Typography.Text>
                  Parecer da entrevista:{' '}
                  <Typography.Text type="danger" strong>
                    Não qualificado
                  </Typography.Text>
                </Typography.Text>
                <br />
              </>
            )}
            {interviewHistoryChangedFields?.opinion_justification && (
              <>
                <Typography.Text>Justificativa alterada.</Typography.Text>
                <br />
              </>
            )}
            {interviewHistoryChangedFields?.annotations && (
              <>
                <Typography.Text>Anotações alteradas.</Typography.Text>
                <br />
              </>
            )}
          </>
        )}
      </Card>
    </Timeline.Item>
  );
};

export default ApplicantInterviewEventTimeline;
